import { Link } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import './NavProfileDropdown.css';

export default function NavProfileDropdown({ user, handleLogOut, handleDropdownClick }) {
  return (
    <div className='NavProfileDropdown dropdown profileDropDown navItem'>
        <div className='profileDropDownToggle' id="profileDropDownToggle" data-title='Profile' data-bs-toggle="dropdown" aria-expanded="false">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
            <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
            </svg>
            <span>&nbsp;&nbsp;</span>
            <svg width="12" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L8.5 8L16 1" stroke="#262626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </div>
        <div className='dropdown-menu profileDropDown' aria-labelledby="profileDropDownToggle">
            <div className='userInfo' onClick={handleDropdownClick}>
            <div className='profileImage'>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
                </svg>
            </div>
            <div>
                <h6 className='m-0'><strong>{capitalizeFirstLetter(user.firstName)} {capitalizeFirstLetter(user.lastName)}</strong></h6>
                <p className='m-0 tertiaryText'>{user.email}</p>
            </div>
            </div>
            <Link className='dropdown-item' to={`/userProfile`} target='_blank'>View Profile</Link>
            <Link className='dropdown-item d-flex justify-content-between' to={'/'} onClick={handleLogOut}>
            <span>Log out</span>
            <svg className='logout' onClick={handleLogOut} width="20" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.33333 14H2.44444C2.06135 14 1.69395 13.8478 1.42307 13.5769C1.15218 13.306 1 12.9386 1 12.5556V2.44444C1 2.06135 1.15218 1.69395 1.42307 1.42307C1.69395 1.15218 2.06135 1 2.44444 1H5.33333M10.3889 11.1111L14 7.5M14 7.5L10.3889 3.88889M14 7.5H5.33333" stroke="#F83D34" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            </Link>
        </div>
    </div>
  )
}
